import i18n from 'i18next'

export function NumberParts(
  language: string,
  type: Intl.NumberFormatPartTypes,
) {
  return Intl.NumberFormat(language)
    .formatToParts(1000.1)
    .find((x) => x.type === type)?.value
}

export function GetCurrentLanguageNumberPart(
  numberFormatPart: Intl.NumberFormatPartTypes,
) {
  return NumberParts(i18n.language, numberFormatPart)
}

export const LocalizedParseFloat = (
  value: string,
  fallback?: number,
  decimalPlaces?: number,
) => {
  if (!value) return fallback !== undefined ? fallback : NaN

  const decimalSeparator = GetCurrentLanguageNumberPart('decimal') || '.'
  const groupSeparator = GetCurrentLanguageNumberPart('group') || ','

  const normalized = value
    .replace(new RegExp(`\\${groupSeparator}`, 'g'), '')
    .replace(new RegExp(`\\${decimalSeparator}`), '.')

  const parsed = parseFloat(normalized)

  if (decimalPlaces !== undefined && !isNaN(parsed)) {
    return parseFloat(parsed.toFixed(decimalPlaces))
  }

  return parsed
}
